export function checkTestDrive(billing: {
  admins?: number;
  externalUsers?: number;
  active?: boolean;
  testDriveExpiration?: number;
  testDriveActivated?: boolean;
}) {
  if (billing?.active) return false;

  if (
    billing?.testDriveActivated &&
    billing?.testDriveExpiration &&
    billing?.testDriveExpiration >= Date.now()
  )
    return true;

  return false;
}
